import React from 'react';
import PropTypes from 'prop-types';
import Portal from '@/components/Modal/Portal';
import Mask from '@/components/Modal/Mask';

class PopUp extends React.PureComponent {
  static propTypes = {
    children: PropTypes.element,
    hide: PropTypes.func,
    cloneName: PropTypes.string,
  };

  render() {
    return (
      <Portal>
        <Mask hide={this.props.hide} cloneName={this.props.cloneName} />
        {
          this.props.children
        }
      </Portal>
    );
  }
}

export default PopUp;
